import Component from "../component";
import Modal from "../modal/modal";
import getBrand from 'dw-brand-identify';
import Cookies from 'js-cookie';

class HsbcEntry extends Component {

	constructor() {
		super();
		this.guaranteeSection = '';
		this.footerSection = '';
		this._brandObj = getBrand();
	}

	getGuarantee(){
		const guaranteeSec = '/html/content/homepage/uk/'+this._brandObj.id+'/guarantee.html'
		fetch(guaranteeSec)
		.then(response => {
			return response.text();
		}).then((html) => { 
			this.guaranteeSection = html
			if(document.getElementById('guaranteeSection') !== null){
				document.getElementById('guaranteeSection').innerHTML = this.guaranteeSection;
			}
		})
		.catch(function (error) {
			// Catch Network and Server Errors
			console.log('Fetching External HTML', error.message);
		});
	}

	getFooter(){
		const footerSec = '/html/content/common/uk/'+this._brandObj.id+'/footer-2019.html'
		fetch(footerSec)
		.then(response => {
			return response.text();
		}).then((html) => { 
			this.footerSection = html  
			if(document.getElementById('footerSection') !== null){
				document.getElementById('footerSection').innerHTML = this.footerSection;
			}
		})
		.catch(function (error) {
			// Catch Network and Server Errors
			console.log('Fetching External HTML', e.message);
		});
	}

	get template() {
		document.getElementsByTagName('html')[0].style.overflow = "hidden";
		this.getGuarantee();
		this.getFooter();
		return (`
			<div class="hsbc-overlay container">
				<div class="hsbc-bg">
					<div class="container">
						<div class="help-link marg-15-top pull-left">
							<a class="phone" href="tel:03330148174"><span>03330 148 174</span></a>
						</div>
						<div class="logo hsbc-logo">
							<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1084.8 706.8"><rect x="75.8" y="281" width="929.8" height="422.43" fill="none"/><rect x="287.6" y="422.1" width="140.9" height="140.92" fill="#fff"/><polygon points="499 492.6 428.6 422.1 428.6 563 499 492.6" fill="#db0011"/><polygon points="358.1 492.6 428.6 422.1 287.6 422.1 358.1 492.6" fill="#db0011"/><polygon points="217.2 492.6 287.6 563 287.6 422.1 217.2 492.6" fill="#db0011"/><polygon points="358.1 492.6 287.6 563 428.6 563 358.1 492.6" fill="#db0011"/><path d="M786.8,522.9c-14.5,0-22.5-8.1-22.5-22.6V463.1h5.5v35.4c0,4.5.1,9.3,2.7,13.2s8.9,6.8,14.3,6.8,12.8-2.8,15.5-8.9c1.5-3.4,1.6-7.5,1.6-11.1V463.1h5.5v37.2C809.4,514.4,800.9,522.9,786.8,522.9Z"/><path d="M821.1,463.1h5.3V522h-5.3Zm5.6,27,26.2-27H860l-27,26.6L862.8,522h-7.2Z"/><path d="M560.9,496.9H535.3v25.2H522.5v-59h12.8v24.1h25.6V463.1h12.8v59H560.9Z"/><path d="M604.4,523.1c-12.8,0-23.2-5-23.5-19.1h12.9c.1,6.2,3.8,10,10.8,10,5.2,0,11.1-2.6,11.1-8.5s-4-6-10.6-7.9l-4.2-1.2c-9.3-2.7-18.6-6.3-18.6-16.9,0-13.2,12.3-17.6,23.5-17.6s21.3,4,21.4,17.1H614.4c-.5-5.4-3.6-8.5-9.6-8.5s-9.5,2.5-9.5,7.7,3.9,5.7,12.2,8.3l4.9,1.5c10.2,3.2,16.5,6.7,16.5,16.5C628.9,518,616,523.1,604.4,523.1Z"/><path d="M636.1,463.1h20.5c6.5,0,9.1.1,11.6.7,7.2,1.6,12.6,6.3,12.6,14.2S676,489.5,669,491.3c8,1.5,13.9,5.6,13.9,14.3,0,13.4-13.2,16.5-23.6,16.5H636.1Zm20.6,24.5c5.6,0,11.4-1.1,11.4-8s-5.4-7.7-10.6-7.7h-8.9v15.7Zm1.2,25.7c6,0,11.9-1.4,11.9-8.6s-5.1-8.7-11.1-8.7H648.6v17.3Z"/><path d="M716.3,523.1c-19,0-27.6-12.1-27.6-30.1s9.5-31.1,28.3-31.1c11.7,0,23.1,5.2,23.5,18.6H727.2c-.6-5.8-4.5-9-10.2-9-11.5,0-15.1,12.5-15.1,21.9s3.6,20.3,14.7,20.3c5.7,0,10-3.1,10.9-9h13.3C739.3,518.1,728.6,523.1,716.3,523.1Z"/><path d="M523,420.8h3.1V439H523Z"/><path d="M538.6,432.1c0-2-.2-3.9-2.7-3.9s-3.1,2.7-3.1,4.7V439h-2.9v-9.9a27.2,27.2,0,0,0-.1-2.8h2.9v1.9a4.7,4.7,0,0,1,4.1-2.1c3.2,0,4.6,1.8,4.6,4.9v8h-2.9Z"/><path d="M559.7,439.3a4.6,4.6,0,0,1-3.9-2v6.5h-2.9V429.7c0-1.1-.1-2.2-.1-3.4h2.8v2a4.8,4.8,0,0,1,4.2-2.3c3.8,0,5.5,3.1,5.5,6.5S563.6,439.3,559.7,439.3Zm-.5-11.3c-2.6,0-3.5,2.5-3.5,4.7s.7,4.6,3.2,4.6,3.5-2.4,3.5-4.7S561.7,428,559.2,428Z"/><path d="M575.5,437.3a4.4,4.4,0,0,1-4.1,2c-2.5,0-4.5-1.3-4.5-3.9,0-4.3,5.4-4.2,8.5-4.2v-.7c0-1.7-.6-2.8-2.5-2.8a2.1,2.1,0,0,0-2.3,2.2h-2.8c0-3,2.6-3.9,5.1-3.9s5.3,1.1,5.3,4.8v3.8a33.7,33.7,0,0,0,.3,4.4h-2.8C575.6,438.4,575.6,437.8,575.5,437.3Zm-1.1-4.6c-1.8,0-4.6.3-4.6,2.6a2.2,2.2,0,0,0,2.4,2.1c2.8,0,3.2-2.4,3.2-4.7Z"/><path d="M587.8,428.8c-2.5,0-3.4,1.4-3.4,3.7V439h-2.9V426.3h2.8v2.1a4,4,0,0,1,3.8-2.2h.7v2.6Z"/><path d="M596.5,439.2c-2.3,0-3.6-.8-3.6-3.2v-7.7h-2.4v-2h2.4V424l3-1.2v3.5h2.9v2h-2.9v6.6c0,1.5.1,2.1,1.7,2.1h1.2V439Z"/><path d="M610,432.1c0-2-.2-3.9-2.6-3.9s-3.2,2.7-3.2,4.7V439h-2.9v-9.9a27.2,27.2,0,0,0-.1-2.8h2.9v1.9a4.7,4.7,0,0,1,4.1-2.1c3.3,0,4.6,1.8,4.6,4.9v8H610Z"/><path d="M618.2,433.4c0,2.2,1.1,4,3.4,4a2.7,2.7,0,0,0,2.9-2.6h2.9c-.5,3.2-3,4.5-5.9,4.5s-6.2-2.6-6.2-6.4,2.1-6.9,6.3-6.9,5.8,3.3,5.8,7.2h-9.2Zm3.4-5.5c-2.1,0-3.2,1.6-3.3,3.6h6.3C624.6,429.6,623.7,427.9,621.6,427.9Z"/><path d="M636.7,428.8c-2.5,0-3.4,1.4-3.4,3.7V439h-2.9v-8.9c0-.9,0-2.6-.1-3.8h2.8v2.1a4.1,4.1,0,0,1,3.9-2.2h.7v2.6Z"/><path d="M644.1,439.3c-2.8,0-5.2-1.1-5.3-4.3h3a2.2,2.2,0,0,0,2.5,2.5c1.1,0,2.5-.6,2.5-1.9s-1-1.6-2.5-2l-1.3-.3c-2.4-.6-3.8-1.5-3.8-3.6s2.9-3.7,5.2-3.7,4.8,1,4.9,4h-2.8a2,2,0,0,0-2.3-2.2c-1,0-2.2.5-2.2,1.6s.9,1.5,2.3,1.9l1.5.3c2.2.6,3.9,1.4,3.9,3.6S646.7,439.3,644.1,439.3Z"/><path d="M661.4,432.1c0-2.1-.2-3.9-2.7-3.9s-3.1,2-3.1,4.1V439h-2.9V420.8h2.9v7.4a4.8,4.8,0,0,1,4.1-2.1c3.2,0,4.6,1.8,4.6,4.9v8h-2.9Z"/><path d="M667,420.8h3.1v2.6H667Zm.1,5.5H670V439h-2.9Z"/><path d="M680.2,439.3a4.6,4.6,0,0,1-3.9-2v6.5h-2.9V429.7c0-1.1,0-2.2-.1-3.4h2.9v2a4.9,4.9,0,0,1,4.3-2.3c3.7,0,5.4,3.1,5.4,6.5S684.1,439.3,680.2,439.3Zm-.5-11.3c-2.6,0-3.4,2.5-3.4,4.7s.6,4.6,3.2,4.6,3.4-2.4,3.4-4.7S682.2,428,679.7,428Z"/><path d="M709,439l-3.3-10-3.4,10h-3l-4.5-12.7H698l3,9.9,3.2-9.9h3.3l3.3,9.8,2.9-9.8h2.8L712,439Z"/><path d="M718.7,420.8h3.1v2.6h-3.1Zm.1,5.5h2.9V439h-2.9Z"/><path d="M729.9,439.2c-2.2,0-3.5-.8-3.5-3.2v-7.7h-2.5v-2h2.5V424l2.9-1.2v3.5h2.9v2h-2.9v6.6c0,1.5.1,2.1,1.7,2.1h1.2V439Z"/><path d="M743.4,432.1c0-2.1-.1-3.9-2.6-3.9s-3.1,2-3.1,4.1V439h-2.9V420.8h2.9v7.4a4.6,4.6,0,0,1,4-2.1c3.3,0,4.7,1.8,4.7,4.9v8h-3Z"/><polygon points="39.4 5.3 8.8 5.3 8.8 209.9 71.3 209.9 71.3 183.6 39.4 183.6 39.4 5.3" fill="#ca004f"/><path d="M121.1,5.3l-28,204.6H123l4.4-36.1h22.4l4.4,36.1h31.3L157.1,5.3Zm17.6,69.9c.7,9.9,1.6,19.1,2.5,29.8l5.5,44.8H130.5l5.5-44.9C137.1,93.9,137.9,84.6,138.7,75.2Z" fill="#ca004f"/><rect x="209.8" y="5.3" width="30.6" height="204.6" fill="#ca004f"/><polygon points="264.8 31.6 290.8 31.6 290.8 209.9 321.4 209.9 321.4 31.6 347.4 31.6 347.4 5.3 264.8 5.3 264.8 31.6" fill="#ca004f"/><polygon points="424.6 87.8 402.6 87.8 402.6 5.3 372 5.3 372 209.9 402.6 209.9 402.6 113.7 424.6 113.7 424.6 209.9 455 209.9 455 5.3 424.6 5.3 424.6 87.8" fill="#ca004f"/><path d="M579.9,113.1c-.7,7.3-1.3,13.9-1.8,20.6-.5-6.7-1-13.3-1.6-20.7L566,5.3H534.2L523.9,113.1c-.7,6.9-1.2,13.3-1.7,19.9-.5-6.3-1-12.7-1.7-20L509.9,5.3H479.3l25.3,204.6h33.7l9.1-96.2c1.1-11.6,1.9-21.2,2.6-30.7.7,9.7,1.6,19.2,2.6,30.7l8.9,96.2h34L620.2,5.3H590.5Z" fill="#ca004f"/><path d="M656.4,5.3,628.3,209.9h30l4.4-36.1H685l4.4,36.1h31.4L692.3,5.3Zm17.5,69.9c.8,9.9,1.6,19.1,2.6,29.8l5.5,44.8H665.7l5.5-44.9C672.3,93.9,673.2,84.6,673.9,75.2Z" fill="#ca004f"/><rect x="745" y="5.3" width="30.6" height="204.6" fill="#ca004f"/><polygon points="800.1 31.6 826.1 31.6 826.1 209.9 856.7 209.9 856.7 31.6 882.7 31.6 882.7 5.3 800.1 5.3 800.1 31.6" fill="#ca004f"/><polygon points="937.8 113.6 968.6 113.6 968.6 88.5 937.8 88.5 937.8 31.6 972.4 31.6 972.4 5.3 907.2 5.3 907.2 209.9 974.1 209.9 974.1 183.6 937.8 183.6 937.8 113.6" fill="#ca004f"/><path d="M1057,105.7l-12.7-20.8c-11.8-18.8-16.6-31.9-16.6-45.3,0-8.1,3.1-12.2,9.2-12.2s10.9,2.6,10.9,21.5V74.4l28.9-5.5V48.1c0-30-13.3-45.2-39.5-45.2s-38.7,13.9-38.7,40.3c-.1,19.7,7.5,36.1,20.8,57.6l12.6,21.1c12.8,21.2,18.1,35.7,18.1,50.1,0,7.2-1.9,15.6-10.7,15.6-6.2,0-12.8-1.9-12.8-25.7V134.5L997,140.2v22.4c0,41.1,22.8,49.7,41.9,49.7,26.3,0,40.8-15.5,40.8-43.5C1079.7,146.8,1071,128.3,1057,105.7Z" fill="#ca004f"/></svg>
						</div>
			
						<div style="margin-top:160px">
							<h1 class="intro-text">Welcome to your perfect wines</h1>
							<div class="hsbc-card-popup">
								<div class="card-section">
									<h4 style="margin: 0 0 30px">Please input the first 6 digits of your card number</h4>
									<div class="card-field">
										<div class="hsbc-form">
											<input data-id="0" type="tel" aria-label="first pin" inputmode="numeric" class="cnn ccn" pattern="^[1-9]\d*$" maxlength="2" id="qty" onfocus="this.placeholder = ''"/>
											<input data-id="1" type="tel" aria-label="second pin" inputmode="numeric" class="cnn ccn" pattern="^[1-9]\d*$" maxlength="2" id="qty" onfocus="this.placeholder = ''"/>
											<input data-id="2" type="tel" aria-label="third pin" inputmode="numeric" class="cnn ccn" pattern="^[1-9]\d*$" maxlength="2" id="qty" onfocus="this.placeholder = ''"/>
											<input data-id="3" type="tel" aria-label="fourth pin" inputmode="numeric" class="cnn ccn" pattern="^[1-9]\d*$" maxlength="2" id="qty" onfocus="this.placeholder = ''" />
											<input data-id="4" type="tel" aria-label="fifth pin" inputmode="numeric" class="cnn ccn" pattern="^[1-9]\d*$" maxlength="2" id="qty" onfocus="this.placeholder = ''"/>
											<input data-id="5" type="tel" aria-label="sixth pin" inputmode="numeric" class="cnn ccn" pattern="^[1-9]\d*$" maxlength="2" id="qty" onfocus="this.placeholder = ''" />
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star margin-30-right" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star margin-30-right" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<input type="text" readonly tabindex="-1" class="cnn cnn-star" value="*"/>
											<span class="ValidationErrors scrollemail alert alert-danger hsb-modal-error">Input fields cannot be empty</span>
										</div>
										<hr class="hsbc-line"/>
										<p>Please ensure you have enough points when placing your order. If you don’t hold sufficient points, you will be subject to additional charges from HSBC.</p>
										<p>At this stage we do not want your full card details, this is only to show you information relevant to your account. </p>	
										<div class="continue-ctn">						
											<a type="button" class="hsbc-continue btn btn-primary" value="">Continue</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div id='guaranteeSection'></div>
			<div id='footerSection'></div>
		`);
	}

	postCardNumber(cardNumber){
		var url = '/api/priceToPoints/card/validateBinRange';
		var data = {"cardId": cardNumber };
		fetch(url, {
		method: 'PUT',
		body: JSON.stringify(data),
		headers:{
			'Content-Type': 'application/json'
		}
		}).then(res => res.json())
		.then(response => {
			document.querySelector('.hsb-modal-error').innerHTML = response.statusMessage;
			if(response.statusMessage == 'successful'){
				document.getElementsByTagName('html')[0].style.overflow = "auto";				
				this.modal.close();
				location.reload();
			}else{
				document.querySelector('.hsb-modal-error').style.display = "block";
			}
		})
		.catch(error => console.error('Error:', error));
	}

	loadItemToModal() {
		this.modal = new Modal({
			body: this.template,
			containsForm: true,
			showFooter: false,
			largeModal: true,
			id: 'hsbc-card-overlay',
		});

		/**
		 * Open the modal
		 */
		this.modal.open();
		
		/**
		 * 
		 * do not close the modal on esc 
		 */
		document.onkeydown = function(evt) {
			evt = evt || window.event;
			if (evt.keyCode == 27) {
				return false;
			}
			if (evt.keyCode == 13) {
				continueButton.click();
			}
		};
		
		let continueButton = Array.from(document.querySelectorAll('.hsbc-continue'))[0];
		let inputElement = Array.from(document.querySelectorAll('.ccn'));
		const errorEle = document.querySelector('.hsb-modal-error');
		let cardNum = [];

		const getNumber = (value) => {
			return value ? value.replace(/\D/g,'') : '';
		};

		const goToPreviousField = (target) => {
			if(target.previousElementSibling && target.previousElementSibling.tagName === 'INPUT') {
				target.previousElementSibling.focus();
			}
		}

		const goToNextField = (target) => {
			if(target.nextElementSibling && target.nextElementSibling.tagName === 'INPUT'){
				target.nextElementSibling.focus();
			}
		}

		inputElement.forEach((field, i) => {
			field.addEventListener('keyup', (e) => {
				//Allow arrow key to move backward and forward b/w the fields
				if(e.keyCode === 37 || (e.keyCode === 8 && !e.target.value)){
					goToPreviousField(e.target);
				}else if(e.target.value && e.keyCode === 39){
					goToNextField(e.target)
				}
				if (e.keyCode === 13) {
					e.preventDefault();
					continueButton.click();
				}
			});

			//input listener support for both key and touch devices
			field.addEventListener('input', (e) => {
				errorEle.style.display = 'none';
				var target = e.srcElement || e.target;
				var numOnlyValue = getNumber(target.value);

				if (numOnlyValue) {
					if(target.hasOwnProperty("oldValue") && target.oldValue !== numOnlyValue) {
						target.value = parseInt(numOnlyValue.toString().replace(target.oldValue,'').split('').pop());
					}else {
						target.value = numOnlyValue.split('').pop();
					}

					target.oldValue = target.value;
					target.oldSelectionStart = target.selectionStart;
					target.oldSelectionEnd = target.selectionEnd;
				} else if (target.value && target.hasOwnProperty("oldValue")) { // remove last input of invalid value
					target.value = target.oldValue;
					target.setSelectionRange(target.oldSelectionStart, target.oldSelectionEnd);
				} else { //input is empty remove the stored previous value
					target.oldValue = "";
					target.value = "";
				}
				if(!target.value){
					errorEle.style.display = "block";
				}
				var inputLength = target.value.length;
				if (inputLength > 0) {
					goToNextField(e.target);
				}
				// // Move to previous field if empty (user pressed backspace)
				else if (inputLength === 0) {
					goToPreviousField(e.target);
				}
			})
		});

		
		
		
		continueButton.addEventListener("click", (e) => {
			let copyNum = [];
			inputElement.forEach((field, i) => {
				if(field.value !== ''){
					copyNum.push(field.value);
				}else{
					errorEle.style.display = "block";
				}
			});
			cardNum = copyNum ;
			if (cardNum.length === 6){
				cardNum = cardNum.join('');
				this.postCardNumber(cardNum);
			}
		});
	}
}
export default HsbcEntry;